'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterOption {
  label: string;
  value: string;
}

interface ProgramFilterProps {
  selectedAge: string;
  selectedLevel: string;
  selectedGoal: string;
  onAgeChange: (value: string) => void;
  onLevelChange: (value: string) => void;
  onGoalChange: (value: string) => void;
  onReset: () => void;
}

const ProgramFilter = ({
  selectedAge,
  selectedLevel,
  selectedGoal,
  onAgeChange,
  onLevelChange,
  onGoalChange,
  onReset,
}: ProgramFilterProps) => {
  const ageGroups: FilterOption[] = [
    { label: 'All Ages', value: 'all' },
    { label: 'Kids (6-10)', value: 'kids' },
    { label: 'Teens (13-17)', value: 'teens' },
    { label: 'Adults (18-54)', value: 'adults' },
    { label: 'Seniors (55+)', value: 'seniors' },
  ];

  const levels: FilterOption[] = [
    { label: 'All Levels', value: 'all' },
    { label: 'Beginner', value: 'beginner' },
    { label: 'Intermediate', value: 'intermediate' },
    { label: 'Advanced', value: 'advanced' },
  ];

  const goals: FilterOption[] = [
    { label: 'All Goals', value: 'all' },
    { label: 'Speed Training', value: 'speed' },
    { label: 'Strength Building', value: 'strength' },
    { label: 'General Fitness', value: 'fitness' },
    { label: 'Athletic Performance', value: 'performance' },
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-bold text-primary flex items-center space-x-2">
          <Icon name="FunnelIcon" size={20} variant="solid" className="text-accent" />
          <span>Filter Programs</span>
        </h3>
        <button
          onClick={onReset}
          className="text-sm text-accent hover:text-accent/80 font-heading font-semibold transition-colors duration-300 flex items-center space-x-1"
        >
          <Icon name="ArrowPathIcon" size={16} variant="outline" />
          <span>Reset</span>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Age Group
          </label>
          <select
            value={selectedAge}
            onChange={(e) => onAgeChange(e.target.value)}
            className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-accent transition-all duration-300"
          >
            {ageGroups.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Fitness Level
          </label>
          <select
            value={selectedLevel}
            onChange={(e) => onLevelChange(e.target.value)}
            className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-accent transition-all duration-300"
          >
            {levels.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Training Goal
          </label>
          <select
            value={selectedGoal}
            onChange={(e) => onGoalChange(e.target.value)}
            className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-accent transition-all duration-300"
          >
            {goals.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ProgramFilter;